import React from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import useGlobal from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import RetencionesMasivasTicketStatus from '../../enum/RetencionesMasivasTicketStatus';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.list;
};

const mapActions = (actions, containers) => {
  return actions.modulo.retenciones_masivas.tickets.list;
};

const RetencionesMasivasTicketsItemActions = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { alignRight, selectedRowKeys, selectedRows } = props;

  const handleOnDownloadActionClick = async () => {
    await actions.download({
      download: true,
      from: props.from,
      to: props.to,
      tickets: selectedRowKeys,
      as: 'link',
    });
  };

  const handleOnRetryStampingActionClick = async () => {
    await actions.retryStamping({ tickets: getRetryStampingTickets() });
  };

  const getRetryStampingTickets = () => {
    return selectedRows
      .filter(function (item) {
        return item.status === RetencionesMasivasTicketStatus.failed().getValue();
      })
      .map(function (item) {
        return item.id;
      });
  };

  const { busy, retry } = state;

  return (
    <Dropdown
      as={ButtonGroup}
      alignRight={alignRight}
    >
      <LoadingButton
        variant="secondary"
        loading={busy || retry}
        onClick={() => {}}
      >
        {busy === true || retry === true ? 'Procesando' : 'Acciones'}
      </LoadingButton>

      <Dropdown.Toggle
        split
        variant="secondary"
        id="dropdown-split-basic"
      />

      <Dropdown.Menu>
        {Guardian.allows('retencion.masiva.descargar.tickets') && (
          <Dropdown.Item
            as="div"
            onClick={handleOnDownloadActionClick}
          >
            Descargar tickets
          </Dropdown.Item>
        )}

        {getRetryStampingTickets().length > 0 && (
          <Dropdown.Item
            as="div"
            onClick={handleOnRetryStampingActionClick}
          >
            Reenviar a timbrado
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RetencionesMasivasTicketsItemActions;
